AgrimarketControllers.controller('deliveryController', [
    '$scope', '$rootScope', '$location', '$filter', 'deliveriesService', 'parametersFactory', 'configurationFactory', 'colonnes', 'currentUserFactory',
    function ($scope, $rootScope, $location, $filter, deliveriesService, parametersFactory, configurationFactory, colonnes, currentUserFactory) {

        if (!$rootScope.ModuleMyAccount.Active)
            $location.path('/login');

        
    }
]);